var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.customer)?_c('div',[_c('h3',[_vm._v("\n    "+_vm._s(_vm.customer.name)),(_vm.isDeleted)?_c('span',{staticClass:"badge badge-danger ml-3"},[_vm._v("GELÖSCHT")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"flex-grow-1"}),_vm._v(" "),(!_vm.isDeleted)?_c('div',[(_vm.isAdmin)?_c('v-button',{staticClass:"btn-danger",attrs:{"working":_vm.deleting},nativeOn:{"click":function($event){return _vm.deleteProfile.apply(null, arguments)}}},[_vm._v("Löschen")]):_vm._e()],1):_vm._e()]),_vm._v(" "),(_vm.calculatesZipcodeCache)?_c('div',{staticClass:"alert alert-info"},[_vm._v("\n    Hinweis: Da der Cache für dynamische PLZ berechnet wird, wird die\n    Einstellung `dynamisch` erst später angewendet. Die Fakes behalten für\n    diese Zeit den alten Wohnort.\n  ")]):_vm._e(),_vm._v(" "),_c('section',[(!_vm.isDeleted)?_c('MediaEditCard',{attrs:{"profile":_vm.customer,"title":"Fakes Media"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("Stammdaten")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Erstellt am")]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[_vm._v("\n                "+_vm._s(_vm.created_at)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Angelegt von")]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[_vm._v("\n                "+_vm._s(_vm.customer.user.name)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("Letzte Nachricht")]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8",domProps:{"innerHTML":_vm._s(_vm.customerLastMessage)}})]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("In/Out Heute")]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[_vm._v("\n                "+_vm._s(_vm.history.today_in)+" / "+_vm._s(_vm.history.today_out)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("In/Out dieser Monat")]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[_vm._v("\n                "+_vm._s(_vm.history.last_month_in)+" / "+_vm._s(_vm.history.last_month_out)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("In/Out letzter Monat")]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[_vm._v("\n                "+_vm._s(_vm.history.this_month_in)+" / "+_vm._s(_vm.history.this_month_out)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"form-group row"},[_c('label',{staticClass:"col-sm-4 col-form-label"},[_vm._v("In/Out insgesamt")]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-8"},[_vm._v("\n                "+_vm._s(_vm.history.total_in)+" / "+_vm._s(_vm.history.total_out)+"\n              ")])])])])]),_vm._v(" "),(!_vm.isDeleted)?_c('div',{staticClass:"col-8"},[_c('resource',{key:!_vm.allowMark,attrs:{"title":"Ändern","resource":"customerProfile","resourceName":"Fake","original":_vm.customer,"attributes":[
            {
              name: 'sex',
              label: 'Geschlecht',
              type: 'SexSelector'
            },
            {
              name: 'name',
              label: 'Name',
              checkChanged: true
            },
            {
              name: 'country_iso3166',
              label: 'Land',
              type: 'OptionSelector',
              hideable: true,
              hideEvent: 'has-dynamic-zipcode'
            },
            {
              name: 'zipcode',
              label: 'PLZ',
              col: 3,
              hideable: true,
              hideEvent: 'has-dynamic-zipcode'
            },
            {
              name: 'has_dynamic_zipcode',
              label: 'Dynamische PLZ',
              type: 'CheckboxSelector',
              cantDisable: true
            },
            {
              name: 'mark',
              label: 'Als Fake-Profil markieren',
              type: 'CheckboxSelector',
              hidden: !_vm.allowMark
            },
            {
              name: 'birthday',
              label: 'Geburtsdatum',
              type: 'BirthdaySelector',
              withRandomSelector: true
            },
            {
              name: 'physique',
              label: 'Figur',
              type: 'OptionSelector'
            },
            {
              name: 'i_search_for_activity',
              label: 'Ich suche',
              type: 'MultiOptionSelector',
              multiSelect: true
            },
            {
              name: 'interested_in_gender',
              label: 'Interessiert an',
              type: 'SexSelector',
              multiSelect: true
            },
            {
              name: 'height_in_cm',
              label: 'Größe (cm)',
              type: 'SliderSelector',
              max: 220,
              min: 140
            }
          ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Fake-Profil bearbeiten")])])])],1):_vm._e()])],1),_vm._v(" "),(_vm.isAdmin)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-7"},[_c('v-table',{attrs:{"url":'/api/v1/friends/' + _vm.id,"filter":[
          {
            name: 'where',
            attributes: {
              customer_profile_id1: _vm.id,
              accepted: 1
            }
          },
          {
            name: 'with',
            value: ['receiver']
          }
        ],"attributes":[
          {
            attribute: 'receiver',
            type: 'LinkFriendCell',
            name: 'Freund'
          },
          {
            attribute: 'receiver.is_fake',
            name: 'Fake',
            type: 'CheckMarkerCell'
          },
          {
            name: 'Aktion',
            type: 'DeleteFriendCell'
          }
        ]}})],1),_vm._v(" "),_c('div',{staticClass:"col-5"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v-table',{attrs:{"url":'/api/v1/friends/' + _vm.id,"filter":[
              {
                name: 'where',
                attributes: {
                  customer_profile_id1: _vm.id,
                  accepted: null
                }
              },
              {
                name: 'with',
                value: ['receiver']
              }
            ],"attributes":[
              {
                attribute: 'receiver',
                type: 'LinkFriendCell',
                name: 'Freund'
              },
              {
                attribute: 'receiver.is_fake',
                name: 'Fake',
                type: 'CheckMarkerCell'
              },
              {
                name: 'Aktion',
                type: 'DeleteFriendCell'
              }
            ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Offene gesendet")])]),_vm._v(" "),_c('v-table',{attrs:{"url":'/api/v1/friends/' + _vm.id,"filter":[
              {
                name: 'where',
                attributes: {
                  customer_profile_id2: _vm.id,
                  accepted: null
                }
              },
              {
                name: 'with',
                value: ['sender']
              }
            ],"attributes":[
              {
                attribute: 'sender',
                type: 'LinkFriendCell',
                name: 'Freund'
              },
              {
                attribute: 'sender.is_fake',
                name: 'Fake',
                type: 'CheckMarkerCell'
              },
              {
                name: 'Aktion',
                type: 'DeleteFriendCell'
              }
            ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Offene eingehend")])])],1)])])]):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('v-table',{attrs:{"url":"/api/v1/message","filter":[
          {
            name: 'with',
            value: ['sender', 'receiver']
          },
          {
            name: 'where',
            attributes: {
              sender_id: _vm.id
            }
          }
        ],"attributes":[
          {
            attribute: 'id',
            name: 'ID'
          },
          {
            attribute: 'receiver',
            type: 'LinkFriendCell',
            name: 'Freund'
          },
          {
            type: 'DialogLink',
            name: 'Dialog'
          },
          {
            attribute: 'in',
            name: 'IN/OUT',
            type: 'InOrOutCell'
          },
          {
            attribute: 'body',
            name: 'Inhalt'
          },
          {
            attribute: 'type',
            name: 'Typ'
          },
          {
            attribute: 'created_at',
            name: 'Gesendet am',
            type: 'DateTimeCell'
          }
        ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Nachrichten")])])],1)]):_vm._e(),_vm._v(" "),(_vm.isAdmin)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('customer-dialogs-table',{attrs:{"customer":_vm.customer}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('resource',{attrs:{"resource":"customerProfile","notification":"Die Notizen wurden gespeichert","original":_vm.customer,"staticMode":_vm.isDeleted,"attributes":[
          {
            name: 'internal_notes',
            label: 'Intern (admin -> admin)',
            type: 'TextareaSelector',
            rows: 5
          },
          {
            name: 'admin_notes',
            label: 'Admininfo (admin -> moderator)',
            type: 'TextareaSelector',
            rows: 5
          }
        ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Notizen")])])])],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }